export default __webpack_public_path__ + "static/media/microsoft-sql-server-logo.9170c2bd.svg";